import { useCallback } from "react"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { Country } from "@/modules/patients/services/__generated__/PatientFragment.graphql"
import {
  Ch_updateAllPatientAllergiesInput,
  chUpdateAllPatientAllergiesMutation,
  chUpdateAllPatientAllergiesMutation$data,
} from "@/modules/patients/services/ch/__generated__/chUpdateAllPatientAllergiesMutation.graphql"
import { chUpdateAllPatientAllergiesMutation as chMutation } from "@/modules/patients/services/ch/chUpdateAllPatientAllergiesMutation"
import {
  De_updateAllPatientAllergiesInput,
  deUpdateAllPatientAllergiesMutation,
  deUpdateAllPatientAllergiesMutation$data,
} from "@/modules/patients/services/de/__generated__/deUpdateAllPatientAllergiesMutation.graphql"
import { deUpdateAllPatientAllergiesMutation as deMutation } from "@/modules/patients/services/de/deUpdateAllPatientAllergiesMutation"

const useUpdateAllPatientAllergiesMutation = (country: Country) => {
  const mutation = (() => {
    switch (country) {
      case "CH":
        return chMutation
      case "DE":
        return deMutation
    }
  })()

  const [commit] = useMutationWithErrorDialog<
    chUpdateAllPatientAllergiesMutation & deUpdateAllPatientAllergiesMutation
  >(mutation)

  return useCallback(
    (
      input: De_updateAllPatientAllergiesInput & Ch_updateAllPatientAllergiesInput,
      onCompleted?: (res: chUpdateAllPatientAllergiesMutation$data & deUpdateAllPatientAllergiesMutation$data) => void,
      onError?: (res: chUpdateAllPatientAllergiesMutation$data & deUpdateAllPatientAllergiesMutation$data) => void,
    ) => {
      commit({
        variables: {
          input,
        },
        onCompleted(response) {
          const data = response.updateAllPatientAllergies
          if (!data.errors?.length) {
            onCompleted?.(response)
          } else {
            onError?.(response)
          }
        },
      })
    },
    [commit],
  )
}

export { useUpdateAllPatientAllergiesMutation }
